import { api } from './api';

export interface CategoryDTO {
  id: string;
  name: string;
  section: string;
  displayOrder: number;
  // Feature 016 — present on accessible rows; absent on locked stubs.
  visibility?: 'private' | 'org' | 'team' | 'public';
  teamId?: string | null;
  discoverable?: boolean;
  /** Set when the row was returned as a locked stub (viewer can't access, but
   *  it's discoverable). Sidebar should show a lock icon and skip children. */
  locked?: true;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
  coverImage?: string;
}

export interface CreateCategoryInput {
  name: string;
  section: string;
  displayOrder?: number;
  visibility?: 'private' | 'org' | 'team' | 'public';
  teamId?: string | null;
  discoverable?: boolean;
}

export const categoryApi = {
  list(section?: string, branchId?: string): Promise<CategoryDTO[]> {
    const params = new URLSearchParams();
    if (section) params.set('section', section);
    if (branchId) params.set('branchId', branchId);
    const qs = params.toString();
    return api.get<CategoryDTO[]>(`/categories${qs ? `?${qs}` : ''}`);
  },

  create(input: CreateCategoryInput): Promise<CategoryDTO> {
    return api.post<CategoryDTO>('/categories', input);
  },

  update(id: string, input: { name?: string; coverImage?: string }): Promise<CategoryDTO> {
    return api.patch<CategoryDTO>(`/categories/${id}`, input);
  },

  rename(input: { section: string; oldName: string; newName: string; branchId?: string }): Promise<{ section: string; oldName: string; newName: string; branchId?: string }> {
    return api.post<{ section: string; oldName: string; newName: string; branchId?: string }>('/categories/rename', input);
  },

  reorder(section: string, order: string[]): Promise<void> {
    return api.put<void>('/categories/reorder', { section, order });
  },

  delete(id: string): Promise<void> {
    return api.delete<void>(`/categories/${id}`);
  },
};
